// extracted by mini-css-extract-plugin
module.exports = {"status":"Subscribe_status__1RY75","subscribe":"Subscribe_subscribe__1BTGi"};